import Feed from 'containers/feed';
import { useUrlQuery } from 'hooks/useUrlQuery';
import { useLocation } from 'react-router-dom';

export const HighlightPage = () => {
    const query = useUrlQuery();
    const location: any = useLocation();
    return (
        <Feed
            stylistName={query.get('stylistName') as string}
            title={location?.state?.title || ''}
            query={location?.state?.query || ''}
        />
    );
};
